const DEFAULT_LOCAL_API_BASE = 'http://localhost:5001';

export function getApiBase(): string {
  const configuredBase = process.env.REACT_APP_API_BASE?.trim();
  const hasUsableBase =
    configuredBase &&
    configuredBase !== 'undefined' &&
    configuredBase !== 'null';

  return (hasUsableBase ? configuredBase : DEFAULT_LOCAL_API_BASE).replace(/\/$/, '');
}
